import type { ReactElement, ReactNode } from 'react';

export interface EmptyStateProps {
  readonly title: string;
  readonly description?: string;
  readonly action?: ReactNode;
  readonly testId?: string;
}

/**
 * 各視圖在「沒有資料」時的引導畫面。
 *
 * 刻意不顯示一片 0 或 N/A：使用者需要知道的是「下一步該做什麼」，
 * 而不是一個技術上正確但無從行動的空表格。
 */
export function EmptyState({ title, description, action, testId }: EmptyStateProps): ReactElement {
  return (
    <div
      data-testid={testId ?? 'empty-state'}
      className="flex h-full w-full items-center justify-center rounded border border-dashed border-slate-300 bg-slate-50 dark:border-slate-700 dark:bg-slate-800/40"
    >
      <div className="max-w-md px-6 text-center">
        <p className="text-sm font-medium text-slate-700 dark:text-slate-200">{title}</p>
        {description !== undefined ? (
          <p className="mt-2 text-xs leading-relaxed text-slate-500 dark:text-slate-400">{description}</p>
        ) : null}
        {action !== undefined ? <div className="mt-3">{action}</div> : null}
      </div>
    </div>
  );
}
